import React from 'react';
import { injectIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

const SimpleTable = (props) => {
  const { isLoading, config, data, actions, footerInfo } = props;

  return (
    <div className='simple-table d-flex flex-column w-100 mt-4'>
      <div className='simple-table-header d-flex flex-row px-4 py-3 mb-2 bg-gray-200'>
        {Object.keys(config).map((configElement, index) => (
          <div
            key={'header-' + index}
            className={`header-${configElement} col color-gray-700 ${config[configElement].headerClassName}`}
          >
            {config[configElement].headerValue}
          </div>
        ))}
      </div>

      <div className='simple-table-body d-flex flex-column'>
        {isLoading && (
          <div className='mb-2'>
            <Skeleton height={60} />
          </div>
        )}
        {!isLoading &&
          data.map((element, element_index) => (
            <div
              key={'row-' + element_index}
              className={`simple-table-row d-flex flex-row p-4 bg-ix-white mb-2 position-relative ${actions && actions.rowAction ? 'hasAction' : ''}`}
              onClick={
                actions && actions.rowAction
                  ? () => actions.rowAction(element)
                  : null
              }
            >
              {Object.keys(config).map(
                (element_key, element_key_index) =>
                  Object.keys(config).includes(element_key) && (
                    <div
                      key={element_key + '-' + element_key_index}
                      className={`body-${element_key} my-auto col ${config[element_key].rowClassName}`}
                    >
                      {config[element_key].formatValue
                        ? config[element_key].formatValue(element[element_key])
                        : element[element_key]}
                    </div>
                  )
              )}
            </div>
          ))}
      </div>

      {(footerInfo && (
        <div className='taxes-table-footer d-flex flex-row px-4 py-3 bg-gray-200'>
          {footerInfo}
        </div>
      )) || <></>}
    </div>
  );
};

export default injectIntl(SimpleTable);
